<template>
  <div class="profilepage">
    <ProfileForm @doLogout="doLogout" v-on:sectionContent="sectionContent=$event" class="profileform"></ProfileForm>
    <ScrollToTop />
  </div>
</template>

<script>
// @ is an alias to /src
import ProfileForm from "@/components/ProfileForm/ProfileForm.vue";
import ScrollToTop from "@/components/commons/ScrollToTop.vue";
import { defineComponent } from 'vue';
import oneUtils from "../../gcdm-one-library/gcdm-one-utils/src/bootstrap";

export default defineComponent({
    inject:['$c', '$t', 'brandClass', '$navigateByPath'],

  name: "Profile",
  components: { ProfileForm, ScrollToTop },
  mixins: [oneUtils.pageTitleMixin],
  data: () => ({
    isLoading: false,
    sectionContent: null
  }),
  computed: {
    $pageTitle: function () {
      return this.$t("profile_tab_title");
    }
  },
  mounted: function(){
    const query = Object.assign({}, oneUtils.utils.getQueryParams());
    if(this.$router){
      delete query.code;
      if(query.client_id==this.$store.getters.configure("key_for_internal_client_id"))
        delete query.client_id;
      delete query.state;
      this.$router.replace({ query });
    }

    // if(!window['$startupwebcomponent']) oneUtils.utils.tokenExpirationTimeout();
  },
  methods:{

    doLogout(){
      this.$store.dispatch("logout");
      if(window['$startupwebcomponent']){
        const event = new CustomEvent("WEB_COMPONENT_LOGOUT");
        window.dispatchEvent(event);
      }else{
        this.isLoading=true;
        oneUtils.utils.showGlobalLoader();
        const sessionLogout = ()=>{
          oneUtils.httpClient
          .sessionLogout(this.$store.getters.configure("key_for_internal_client_id"))
          .then(() => {
            oneUtils.sessionUtils.cleanLocalStorage();
            this.$navigateByPath('login', {redirectFrom:'profile'});
          })
          .catch((e) => {
            oneUtils.sessionUtils.cleanLocalStorage();
            this.$navigateByPath('login', {redirectFrom:'profile'});
          });
        }
        oneUtils.httpClient
          .tokenLogout()
          .then(() => {
            sessionLogout();
          })
          .catch((e) => {
            sessionLogout();
          });
      }
    }
  }
});
</script>
<style lang="scss" scoped>
.profilepage{
  width: 100%;
  display: flex;
  flex-direction: column;
}

</style>
